import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleCustomerRequest } from '../customer-api-client';
import { Location } from '../../quipli-service/location/location';
import { LocationParsers } from '../../quipli-service/location/location-parsers';

export const useCustomerLocationApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function listLocations(): Promise<Location[]> {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/customer-api/v1/locations`,
      headers: {
        'X-Tenant': tenant,
      },
    };

    const result = await handleCustomerRequest<LocationParsers.LocationJson[]>(config);
    return result.map(LocationParsers.toLocation);
  }

  async function getLocationById(locationId: number): Promise<Location> {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/customer-api/v1/locations/${locationId}`,
      headers: {
        'X-Tenant': tenant,
      },
    };
    const result = await handleCustomerRequest<LocationParsers.LocationJson>(config);
    return LocationParsers.toLocation(result);
  }

  return {
    getLocationById,
    listLocations,
  };
};
